import moment from 'moment-timezone';
import Cookies from 'js-cookie';
import merge from 'lodash.merge';
import CacheInstance from '../components/cache';

window.ucFirst = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

window.getPrettyTimeAgo = pastDate => {
  // Get current time and past time in seconds
  const now = Math.floor(Date.now() / 1000);
  const past = Math.floor(new Date(pastDate).getTime() / 1000);
  const elapsedSeconds = now - past;

  // Handle future dates
  if (elapsedSeconds < 0) {
    return 'In the future';
  }

  // Define time thresholds in seconds
  const SECONDS_IN_MINUTE = 60;
  const SECONDS_IN_HOUR = 3600;
  const SECONDS_IN_DAY = 86400;

  if (elapsedSeconds < SECONDS_IN_MINUTE) {
    return 'Just now';
  }

  if (elapsedSeconds < SECONDS_IN_HOUR) {
    const minutes = Math.floor(elapsedSeconds / SECONDS_IN_MINUTE);
    return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
  }

  if (elapsedSeconds <= SECONDS_IN_DAY) {
    const hours = Math.floor(elapsedSeconds / SECONDS_IN_HOUR);
    return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  }

  // More than 1 day ago: business-friendly US datetime
  return window.getUserTimezoneDate(pastDate).format('MM/DD/YY h:mm A');
};

window.escapeHTML = (str) => {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

window.getPrettyNextCheckin = next_checkin => {

  // Calculate the remaining time until the next check-in in seconds
  const nextCheckinSeconds = parseInt(window.getUserTimezoneDate(next_checkin).format('X')) - parseInt(moment().format('X'));

  if (nextCheckinSeconds > 3600) {

    // If the remaining time is greater than 1 hour, display the number of hours and remaining minutes
    const nextCheckinHours = Math.floor(nextCheckinSeconds / 3600);
    const remainingMinutes = Math.floor((nextCheckinSeconds % 3600) / 60);

    if (remainingMinutes === 0) {
      // If there are no remaining minutes, display only the number of hours
      return `${nextCheckinHours} hour${nextCheckinHours > 1 ? 's' : ''}`;

    } else {
      // Otherwise, display the number of hours and remaining minutes
      return `${nextCheckinHours} hour${nextCheckinHours > 1 ? 's' : ''} ${remainingMinutes} minute${remainingMinutes > 1 ? 's' : ''}`;
    }

  } else if (nextCheckinSeconds > 60) {

    // If the remaining time is between 2 minutes and 1 hour, display the number of minutes
    const nextCheckinMinutes = Math.floor(nextCheckinSeconds / 60);

    // display the number of minutes and remaining seconds
    return `${nextCheckinMinutes} minute${nextCheckinMinutes > 1 ? 's' : ''}`;

  } else {

    // If the remaining time is less than 1 minute, display "Checking in soon"
    return 'Checking in soon';

  }

};

window.getSignalStrengthIcon = rssi => {

  rssi = parseInt(rssi);

  if(rssi === 0) {
    return null;
  }

  if(rssi < -90) {
    return `<img width="15" src="${window.site.home + '/images/wifi-no-signal.svg'}" title="Very bad signal quality (${rssi} dB)" />`;
  } else if(rssi < -80) {
    return `<img width="15" src="${window.site.home + '/images/wifi-no-bars.svg'}" title="Bad signal quality (${rssi} dB)" />`;
  } else if(rssi < -70) {
    return `<img width="15" src="${window.site.home + '/images/wifi-half-bars.svg'}" title="Good signal quality (${rssi} dB)" />`;
  } else {
    return `<img width="15" src="${window.site.home + '/images/wifi-full-bars.svg'}" title="Excellent signal quality (${rssi} dB)" />`;
  }

}

window.getBatteryIconPct = pct => {

  if(isNaN(pct)) {
    return '&ndash;';
  }

  return `${pct}%`;

  // if(pct > 80) {
  //   return `<img src="${window.site.home}/assets/images/battery_level_100.png" class="battery-icon" /> ${pct}%`;
  // } else if(pct > 60) {
  //   return `<img src="${window.site.home}/assets/images/battery_level_80.png" class="battery-icon" /> ${pct}%`;
  // } else if(pct > 40) {
  //   return `<img src="${window.site.home}/assets/images/battery_level_60.png" class="battery-icon" /> ${pct}%`;
  // } else if(pct > 20) {
  //   return `<img src="${window.site.home}/assets/images/battery_level_40.png" class="battery-icon" /> ${pct}%`;
  // } else if(pct > 10) {
  //   return `<img src="${window.site.home}/assets/images/battery_level_20.png" class="battery-icon" /> ${pct}%`;
  // } else {
  //   return `<img src="${window.site.home}/assets/images/battery_level_10.png" class="battery-icon" /> ${pct}%`;
  // }

};

window.getBatteryIcon = voltage => {

  if(isNaN(voltage)) {
    return '&ndash;';
  }

  voltage = parseFloat(voltage);

  const pct = window.getBatteryPercentage(voltage);

  if(pct > 80) {
    return `<img src="${window.site.home}/images/battery_level_100.png" class="battery-icon" /> ${pct}%`;
  } else if(pct > 60) {
    return `<img src="${window.site.home}/images/battery_level_80.png" class="battery-icon" /> ${pct}%`;
  } else if(pct > 40) {
    return `<img src="${window.site.home}/images/battery_level_60.png" class="battery-icon" /> ${pct}%`;
  } else if(pct > 20) {
    return `<img src="${window.site.home}/images/battery_level_40.png" class="battery-icon" /> ${pct}%`;
  } else if(pct > 10) {
    return `<img src="${window.site.home}/images/battery_level_20.png" class="battery-icon" /> ${pct}%`;
  } else {
    return `<img src="${window.site.home}/images/battery_level_10.png" class="battery-icon" /> ${pct}%`;
  }

};

window.getBatteryPercentageForSensor = sensor => {

  if(sensor.last_battPct) {
    return sensor.last_battPct.toFixed(0);
  }

  let voltage = sensor.last_voltage;

  // THE VOLTAGE RANGE IS 2.3v TO 3.0v
  const baseline = 2.30; // LOWEST ALLOWED VOLTAGE
  const remaining_voltage = voltage - baseline;

  // WHAT PERCENT OF 0.7v IS THE REMAINDER?
  // 3.00v = 100%
  // 2.30v =   0%
  // 0.70 v = Max range

  let voltagePct = remaining_voltage / 0.007;

  // IF THE BATTERY LEVEL IS OVER 3.0v
  // DEFAULT TO 100%

  if(voltagePct > 100){ voltagePct = 100; }
  if(voltagePct < 0){ voltagePct = 0; }

  return voltagePct.toFixed(0);

};

window.getBatteryPercentage = voltage => {

  // THE VOLTAGE RANGE IS 2.3v TO 3.0v
  const baseline = 2.30; // LOWEST ALLOWED VOLTAGE
  const remaining_voltage = voltage - baseline;

  // WHAT PERCENT OF 0.7v IS THE REMAINDER?
  // 3.00v = 100%
  // 2.30v =   0%
  // 0.70 v = Max range

  let voltagePct = remaining_voltage / 0.007;

  // IF THE BATTERY LEVEL IS OVER 3.0v
  // DEFAULT TO 100%

  if(voltagePct > 100){ voltagePct = 100; }
  if(voltagePct < 0){ voltagePct = 0; }

  return voltagePct.toFixed(0);

};

window.getUserTempPref = () => {
  if(window.currentUser) {
    return window.currentUser.temp_pref;
  }

  return 'F';

};

window.datetimeToDate = datetime => {

  if(!datetime) return false;

  const match = datetime.match(/(\d\d\d\d)\-(\d\d)\-(\d\d) (\d\d)\:(\d\d)\:(\d\d)/);

  if(!match) {
    return false;
  }

  const d = new Date(
    Date.UTC(
      parseInt(match[1]),
      parseInt(match[2]) - 1,
      parseInt(match[3]),
      parseInt(match[4]),
      parseInt(match[5]),
      parseInt(match[6])
    )
  );

  return d;

};

window.getUserTimezoneDate = datetime => {

  let m = moment(window.datetimeToDate(datetime));

  if(window.currentUser.use_local_timezone && window.currentUser.use_local_timezone == 0) {
    m.tz(window.currentUser.timezone);
  } else {
    m.local(true);
  }

  return m;

};

window.formatTemperature = temp => {
  return window.celsiusToUserTemp(temp, 1) + '&deg;' + window.getUserTempPref();
};

window.userUnitsToCelsiusUnits = (userUnitsValue, decimals=0) => {

  userUnitsValue = parseFloat(userUnitsValue);

  let celUnits;

  if(window.getUserTempPref() === 'F') {
    celUnits = (userUnitsValue / 1.8).toFixed(decimals);
  } else {
    celUnits = userUnitsValue.toFixed(decimals);
  }

  if(Math.abs(celUnits) === 0) {
    return 0;
  } else if(celUnits.includes('.0') && decimals === 1) {
    celUnits = Math.round(celUnits);
  }

  return parseFloat(celUnits);

};

window.celsiusUnitsToUserTemp = (celValue, decimals=0) => {

  celValue = parseFloat(celValue);

  let temp;

  if(window.getUserTempPref() === 'F') {
    temp = (celValue * 1.8).toFixed(decimals);
  } else {
    temp = (celValue).toFixed(decimals);
  }

  if(Math.abs(temp) === 0) {
    return 0;
  } else if(temp.includes('.0') && decimals === 1) {
    temp = Math.round(temp);
  }

  return parseFloat(temp);

};

window.fahrenheitUnitsToUserTemp = (fahValue, decimals=0) => {

  fahValue = parseFloat(fahValue);

  let temp;

  if(window.getUserTempPref() === 'C') {
    temp = (fahValue / 1.8).toFixed(decimals);
  } else {
    temp = (fahValue).toFixed(decimals);
  }

  if(Math.abs(temp) === 0) {
    return 0;
  } else if(temp.includes('.0') && decimals === 1) {
    temp = Math.round(temp);
  }

  return temp;

};

window.fahrenheitToUserTemp = (fahrenheit, decimals = 0) => {

  let temp = 0;

  if(window.getUserTempPref() === 'C') {
    temp = ((fahrenheit - 32) / 1.8).toFixed(decimals);
  } else {
    temp = parseFloat(fahrenheit).toFixed(decimals);
  }

  if(Math.abs(temp) === 0) {
    return 0;
  } else if(temp.includes('.0') && decimals === 1) {
    temp = Math.round(temp);
  }

  return parseFloat(temp);

};

window.celsiusToUserTemp = (celsius, decimals = 0) => {

  if(window.currentUser.temp_pref_digits) {
    if(window.currentUser.temp_pref_digits == 1) {
      decimals = 1;
    } else if(window.currentUser.temp_pref_digits == 2) {
      decimals = 2;
    }
  }

  let temp = 0;

  if(window.getUserTempPref() === 'F') {
    temp = ((celsius * 1.8) + 32).toFixed(decimals);
    temp = parseFloat(temp);
  } else {
    temp = parseFloat(celsius).toFixed(decimals);
  }

  // numerical precision hack
  const roundingCalcPrecision = temp - Math.floor(temp);

  if(roundingCalcPrecision >= 0.989 || roundingCalcPrecision <= 0.011) {
    temp = Math.round(temp);
  }

  return parseFloat(temp);

};

window.userTempToCelsius = (temp, decimals = 0) => {

  if(window.getUserTempPref() === 'F') {
    return ((temp - 32) * 5 / 9).toFixed(decimals);
  }

  return temp;

};

window.logoutNoRedirect = () => {

  Cookies.remove('token');

  window.localStorage.removeItem('token');
  window.localStorage.removeItem('user');

  CacheInstance.remove('one-signal');

};

// next: a page to come back to after signing in again (the login page checks it)
window.logout = (next) => {

  Cookies.remove('token');

  window.localStorage.removeItem('token');
  window.localStorage.removeItem('user');

  CacheInstance.remove('one-signal');

  window.location.href = window.site.home + '/' + (next ? '?next=' + encodeURIComponent(next) : '');

};

window.isLoggedIn = () => {

  let token = window.localStorage.getItem('token');

  if(!token) {
    token = Cookies.get('token');
  }

  return token;

}

window.apiRequest = (type, path, data = {}, settings = {}) => {

  type = type.toLowerCase();

  return new Promise((resolve, reject) => {

    // Merge defaults with the provided settings, including the new preferCache flag.
    settings = merge({
      tryCount: 0,
      maxTries: 3,
      timeout: 20000,
      preferCache: false
    }, settings);

    // Create a cache container on the window object if it doesn't exist.
    window.apiCache = window.apiCache || {};

    // If preferCache is enabled, check for a valid cached result
    if (settings.preferCache && window.apiCache[path]) {
      const cached = window.apiCache[path];
      const now = Date.now();
      // If the cached response is less than 5 minutes old (300,000 ms), return it.
      if ((now - cached.timestamp) < 300000) {
        return resolve(cached.data);
      }
    }

    let token = window.localStorage.getItem('token');

    if (!token) {
      token = decodeURIComponent(Cookies.get('token'));
    }

    let timeout = settings.timeout;

    if (token) {

      const ajaxSettings = {
        url: window.site.api + path,
        type,
        dataType: 'json',
        timeout,
        beforeSend: function(xhr) {
          xhr.setRequestHeader('Authorization', `Bearer ${encodeURIComponent(token)}`);
        },
        success: r => {
          if (r.type) {

            // Successfully communicated with the API, so update the offline state if necessary.
            if (window.site.isOffline === 1) {
              window.site.isOffline = 0;
              window.PubSub.publish('online', path);
            }

            // Save the response to the cache if preferCache is enabled.
            if (settings.preferCache) {
              window.apiCache[path] = {
                data: r,
                timestamp: Date.now()
              };
            }

            resolve(r);
          } else {
            reject(r);
          }
        },
        error: (xhr, textStatus, errorThrown) => {

          // Handle offline errors and connection timeouts.
          if (xhr.status === 0 || textStatus === 'timeout') {

            settings.tryCount++;

            if (settings.tryCount <= settings.maxTries) {
              resolve(window.apiRequest(type, path, data, settings));
            } else {

              // Failed to communicate with the API; mark as offline.
              if (window.site.isOffline === 0) {
                window.site.isOffline = 1;
                window.PubSub.publish('offline', path);
              }

              if (type === 'get' || path.includes('authenticate')) {
                const cacheItem = CacheInstance.get(path);
                if (cacheItem) {
                  resolve(cacheItem.value);
                }
              } else {
                reject('timeout');
              }
            }
          }
        },
      };

      if (type === 'post') {
        ajaxSettings.data = data;
      }

      $.ajax(ajaxSettings);

    } else {
      reject('no token');
    }
  });
};

window.apiRequestNoToken = (type, path, data = {}) => {

  return new Promise((resolve, reject) => {

    const settings = {
      url: window.site.api + path,
      type,
      dataType: 'json',
      success: r => {
        if (r.type) {
          resolve(r);
        } else {
          reject(r);
        }
      },
      error: (xhr, textStatus, errorThrown) => {

        // 0 = offline / connection
        // timeout the connection is slow
        if (xhr.status === 0 || textStatus === 'timeout') {
          reject('timeout');
        }

      },
    };

    if(type === 'post') {
      settings.data = data;
    }

    $.ajax(settings);

  });

}
